import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./channel-topic-row.module.scss";
import DiscreteInput from "../../../elements/discrete-input";
import EditableChannelTopic from "./editable-channel-topic";
import { classArr } from "../../../helper/style-helper";
import IconClose from "../../../dynamicicons/icon-close";
import * as globals from "../../../styles/global.icss.scss";
import VelavuIconButton from "../../../elements/velavu-icon-button";
import HoverTooltip from "../../../elements/hover-tooltip";
import { useCounter } from "../../../helper/hook-helper";

export interface ChannelTopicRowProps {
	channelTopic: EditableChannelTopic;
	errorMessage?: string | undefined;
	onChange?: (channelTopic: EditableChannelTopic) => void;
	onRemove?: () => void;
	readOnly?: boolean;
}

export default function ChannelTopicRow(props: ChannelTopicRowProps) {
	const { t } = useTranslation();
	const [
		interactionCounter,
		increaseInteractionCounter,
		decreaseInteractionCounter,
	] = useCounter();
	const isPronounced = interactionCounter > 0;

	return (
		<tr
			className={classArr(
				styles.row,
				isPronounced && styles.rowPronounced,
			)}
			onMouseEnter={increaseInteractionCounter}
			onMouseLeave={decreaseInteractionCounter}
		>
			<td className={styles.channelCell}>
				<HoverTooltip
					wrapperClassName={styles.channelInputWrapper}
					edge="right"
					delay={0}
					tooltip={props.errorMessage}
				>
					<DiscreteInput
						className={styles.channelInput}
						value={props.channelTopic.wirepas_channel}
						onChange={(value) => {
							props.onChange?.({
								...props.channelTopic,
								wirepas_channel: value,
							});
						}}
						readOnly={props.readOnly}
						placeholder="1"
						type="text"
						reveal={isPronounced}
						error={props.errorMessage !== undefined}
						onFocus={increaseInteractionCounter}
						onBlur={decreaseInteractionCounter}
					/>
				</HoverTooltip>
			</td>
			<td
				className={classArr(
					styles.endpointCell,
					isPronounced && styles.endpointCellBorder,
				)}
			>
				<div className={styles.endpointCellLayout}>
					<DiscreteInput
						className={styles.endpointInput}
						value={props.channelTopic.mqtt_topic}
						onChange={(value) => {
							props.onChange?.({
								...props.channelTopic,
								mqtt_topic: value,
							});
						}}
						readOnly={props.readOnly}
						placeholder={t(
							"settings.broker.channel_topic.enter_topic_string",
						)}
						reveal={isPronounced}
						onFocus={increaseInteractionCounter}
						onBlur={decreaseInteractionCounter}
					/>

					{!props.readOnly && (
						<VelavuIconButton
							className={classArr(
								styles.removeButton,
								isPronounced && styles.removeButtonShown,
							)}
							onClick={props.onRemove}
						>
							<IconClose size={16} color={globals.textTertiary} />
						</VelavuIconButton>
					)}
				</div>
			</td>
		</tr>
	);
}
